import { useQuery } from "@tanstack/react-query"
import { api } from "@/lib/api"
import type { Trigger, TriggerDto } from "@/models/trigger"
import { TriggerDtoSchema, triggerDtoListSchema, triggerFromDto } from "@/models/trigger"

export function useGetTriggers(options = {}) {
  return useQuery<Trigger[]>({
    queryKey: ["triggers"],
    queryFn: async () => {
      const response = await api.get("/api/triggers", triggerDtoListSchema)
      return response.Data.map((dto) => triggerFromDto(dto))
    },
    ...options,
  })
}

export function useGetTrigger(id: string, options = {}) {
  return useQuery<Trigger>({
    queryKey: ["triggers", id],
    queryFn: async () => {
      const response = await api.get(`/api/triggers/$id`, TriggerDtoSchema, {
        pathReplace: { $id: id },
      })
      return triggerFromDto(response as TriggerDto)
    },
    enabled: !!id,
    ...options,
  })
}
